export const enum ProductGroupsTableColumnsEnum {
    Type = 'type',
    Name = 'name',
    Products = 'products',
    UpdatedAt = 'updatedAt',
    Services = 'services',
    Status = 'status',
    Actions = 'actions',
}

export const PRODUCT_GROUPS_SERVICES_COLUMN_MIN_WIDTH = 200;
export const PRODUCT_GROUPS_STATUS_COLUMN_WIDTH = 140;
export const PRODUCT_GROUPS_TABLE_SCROLL_X = 800;
